export const filterMap = <K, V>(map: Map<K, V>, pred: (v: V) => boolean) => {
    for (const [ key, value ] of map.entries()) {
        if (!pred(value)) {
            map.delete(key);
        }
    }
};
